import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const MobileCare: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 652 446"
    width={652}
    height={446}
    fill="none"
    {...props}
  >
    <path
      fill="#009CBD"
      d="M638.131 45.628 533.616 1.57a15.209 15.209 0 0 0-10.635-.477l-19.393 6.36.238 6.45h8.61c0 .089-.03.178-.045.268l-34.332 339.163a19.498 19.498 0 0 0 9.13 18.529l106.243 65.715c8.892 5.511 20.48-.209 21.538-10.62l36.342-359.122c.968-9.488-4.379-18.5-13.181-22.208Z"
    />
    <path
      fill="#0072A6"
      d="m649.078 55.846-147.128 61.44-23.891 236.033a19.498 19.498 0 0 0 9.13 18.529l102.415 63.362-6.881 4.498 3.604 5.481 19.125-6.271s.074-.029.119-.044h.06v-.015c4.855-1.743 8.743-6.092 9.339-11.901l36.342-359.122c.432-4.23-.402-8.37-2.234-11.975v-.015Z"
    />
    <path
      fill="#D9F6FA"
      d="M581.634 435.269c1.207 0 3.218-.849 3.456-3.113l36.343-359.122c.491-4.84-2.19-9.354-6.673-11.245L510.245 17.73a4.547 4.547 0 0 0-1.803-.373c-2.025 0-4.319 1.46-4.602 4.17l-34.332 339.164c-.342 3.307 1.281 6.584 4.096 8.327l106.243 65.714c.581.358 1.162.536 1.772.536h.015Z"
    />
    <path
      fill="#B2EBF2"
      d="m473.621 369.018 106.242 65.715c.581.358 1.162.536 1.773.536 1.206 0 3.217-.849 3.455-3.113l27.332-269.963C554.9 139.568 483.391 223.797 476.719 289.72l-7.18 70.972c-.342 3.307 1.281 6.584 4.096 8.326h-.014Z"
    />
    <path
      fill="#FFB185"
      d="M582.395 374.246a3597 3597 0 0 1 14.045 2.815l8.147-83.081s-5.213-.164-13.598-.418l-8.594 80.684Z"
    />
    <path
      fill="#00BED5"
      d="M618.931 51.913 514.416 7.855c-9.517-4.007-20.182 2.323-21.224 12.6L458.86 359.62a19.498 19.498 0 0 0 9.13 18.529l106.243 65.715c8.892 5.511 20.48-.209 21.537-10.62L632.113 74.12c.968-9.487-4.379-18.499-13.182-22.207Zm2.503 21.135L585.091 432.17c-.223 2.264-2.234 3.113-3.456 3.113-.625 0-1.206-.178-1.772-.536L473.62 369.032c-2.83-1.742-4.438-5.019-4.096-8.326l34.332-339.163c.268-2.711 2.577-4.17 4.602-4.17a4.6 4.6 0 0 1 1.803.372l104.515 44.058c4.483 1.891 7.164 6.404 6.672 11.245h-.014Z"
    />
    <path
      fill="#FFB185"
      d="M467.257 289.929c-21.567-.536-47.26-6.792-62.869-10.903-8.743-2.308-42.852-3.947-47.574-4.2-4.721-.253-34.54 8.177-39.262 8.937-4.721.759-6.657 6.792-3.515 10.426 4.32 5.004 18.618 9.279 32.113 6.613 10.918-2.145 23.563.372 32.604 2.815 4.29 1.162 1.519 3.47-3.381 7.283 0 0-36.313 26.647-62.885 33.603l21.508 57.314c65.059 0 105.692-47.558 135.466-47.558 12.452 0 98.334 17.039 121.301 21.641l8.311-82.113c-23.22-.7-113.094-3.411-131.831-3.888l.014.03Z"
    />
    <path
      fill="#ED9877"
      d="M546.676 367.262s35.925 1.787 48.333-33.096l-4.231 41.749-44.102-8.653Z"
    />
    <path
      fill="#FFB185"
      d="M334.012 401.846s-9.502 1.668-21.507-10.665c-10.546-10.843-45.935-62.884-47.037-64.701-2.011-3.322 9.353-9.22 15.773-3.024 9.428 9.101 32.991 36.149 36.313 39.277 1.385 1.311 14.686 16.384 14.686 16.384l1.772 22.744v-.015Z"
    />
    <path
      fill="#FFB185"
      d="M309.659 387.295c-10.292 0-27.376-14.731-31.695-18.454-11.35-9.786-42.599-38.577-44.356-39.933-5.034-3.857 7.03-11.826 15.177-7.238 11.961 6.717 40.067 29.089 44.252 31.368 1.758.953 22.148 11.498 22.148 11.498s1.4 22.759-5.526 22.759Z"
    />
    <path
      fill="#FFB185"
      d="M329.157 354.765s18.052 21.612 13.137 22.357c-1.996.298-118.248-19.691-120.542-20.301-3.47-.909-2.115-11.663 9.056-11.663 14.626 0 69.796 2.741 81.696-.64 4.216-1.192 16.667 10.232 16.667 10.232l-.014.015Z"
    />
    <path
      fill="#ED9877"
      d="M321.261 367.871c5.288 5.199 13.018 9.354 24.383 10.233 11.305.864 3.366-14.984 6.955-33.289 2.83-14.373 16.712-27.555 22.774-33.885 0 0-36.313 26.646-62.885 33.602l8.758 23.339h.015Z"
    />
    <path
      fill="#FFB185"
      d="M334.013 401.846c-12.854.075-21.046-10.247-24.353-14.552-2.666-3.47-10.113-29.7-10.039-33.125.06-2.473-1.877-22.238-1.132-24.71 1.624-5.437 14.016-1.564 15.059 9.77.327 3.62.789 9.324 1.891 12.944 1.981 6.509 6.152 14.939 11.379 19.303 6.792 5.66 18.812 6.643 18.812 6.643l-11.632 23.742.015-.015Z"
    />
    <path
      fill="#FF612B"
      d="M418.361 181.466a51.387 51.387 0 0 0-13.48-23.593l-.029-.029c-6.286-6.271-13.778-10.59-21.746-12.959a51.887 51.887 0 0 0-8.624-1.772c-15.178-1.802-31.011 3.113-42.658 14.76l-11.484 11.484-.03-.03-11.454-11.454c-20.167-20.167-52.875-20.167-73.043 0a54.546 54.546 0 0 0-2.949 3.218c-17.158 20.301-16.19 50.686 2.949 69.825l82.248 82.248c1.251 1.251 3.277 1.251 4.513 0 13.51-13.509 83.141-83.141 83.499-83.514 12.452-13.315 16.548-31.591 12.273-48.184h.015Z"
    />
    <path
      fill="#EB4600"
      d="M235.859 204.747c-2.056-12.065-12.02-23.831-9.563-32.425.268-.954.358-1.564.328-1.907-9.652 18.38-7.462 41.332 6.554 57.627.387.104.61.134.61.134s5.049-5.913 2.071-23.414v-.015ZM314.367 163.355l-5.496-5.496c-8.773-8.773-19.899-13.718-31.338-14.865 10.024 3.545 16.891 16.339 26.14 19.318 4.424 1.43 7.998 1.639 10.694 1.043ZM418.362 181.467a51.368 51.368 0 0 0-13.48-23.593l-.029-.03a51.416 51.416 0 0 0-18.127-11.722c3.381 1.668 6.509 3.843 9.25 6.583l.029.03c5.467 5.467 8.773 12.407 10.009 19.959 2.369 14.492 2.354 32.976-43.134 79.462-20.197 20.629-56.867 48.929-72.105 33.707l27.287 27.286a3.18 3.18 0 0 0 4.513 0c13.51-13.509 83.142-83.141 83.499-83.513 12.452-13.316 16.548-31.592 12.273-48.184l.015.015Z"
    />
    <path
      fill="#00448A"
      d="M173.943 353.334 139.611 14.171c0-.09-.03-.179-.045-.268h8.609l.239-6.45-19.393-6.36a15.211 15.211 0 0 0-10.635.477L13.871 45.628A21.752 21.752 0 0 0 .69 67.836l36.342 359.122c1.058 10.411 12.646 16.116 21.538 10.62l106.242-65.715a19.496 19.496 0 0 0 9.131-18.529Z"
    />
    <path
      fill="#000C44"
      d="m173.943 353.335-23.891-236.034L2.924 55.861A21.597 21.597 0 0 0 .69 67.837l36.343 359.122c.596 5.824 4.468 10.158 9.339 11.901l.06.015c.044 0 .074.029.118.044l19.125 6.271 3.604-5.481-6.88-4.499 102.414-63.361a19.498 19.498 0 0 0 9.13-18.529v.015Z"
    />
    <path
      fill="#D9F6FA"
      d="M70.366 435.269c-1.207 0-3.218-.849-3.456-3.113L30.567 73.034c-.491-4.84 2.19-9.354 6.673-11.245L141.755 17.73a4.547 4.547 0 0 1 1.803-.373c2.025 0 4.319 1.46 4.602 4.17l34.332 339.164c.342 3.307-1.281 6.584-4.096 8.327L72.153 434.733c-.58.358-1.162.536-1.772.536h-.015Z"
    />
    <path
      fill="#B2EBF2"
      d="M178.381 369.018 72.138 434.733c-.581.358-1.162.536-1.773.536-1.221 0-3.217-.849-3.455-3.113l-4.111-40.617c-10.337-102.132 13.45-226.412 95.861-266.195l23.817 235.348c.342 3.322-1.266 6.584-4.096 8.326Z"
    />
    <path
      fill="#733127"
      d="M41.353 87.571c-5.899.12-9.31.045-9.31.045l-4.29.045L36.2 167.6l3.798-1.475s3.396-1.028 8.624-2.592l-7.254-75.947-.014-.015Z"
    />
    <path
      fill="#0072A6"
      d="M193.158 359.62 158.826 20.456c-1.043-10.262-11.722-16.607-21.225-12.6L33.086 51.912a21.752 21.752 0 0 0-13.182 22.208l36.343 359.122c1.058 10.412 12.645 16.116 21.538 10.62l106.242-65.715a19.5 19.5 0 0 0 9.131-18.528Zm-14.776 9.398L72.139 434.733c-.58.357-1.161.536-1.772.536-1.206 0-3.217-.849-3.456-3.113L30.57 73.034c-.492-4.841 2.19-9.354 6.673-11.246L141.757 17.73a4.539 4.539 0 0 1 1.802-.372c2.026 0 4.319 1.46 4.602 4.17l34.332 339.164c.343 3.307-1.281 6.583-4.096 8.326h-.015Z"
    />
    <path
      fill="#733127"
      d="m214.545 80.303-12.66-23.876s27.793-7.537 37.057-10.054c13.629-3.694 54.514-14.79 54.514-14.79 6.777-1.981 9.593 9.19-1.847 13.94-6.568 2.741-25.827 11.425-43.447 19.423a13659.41 13659.41 0 0 0-33.632 15.342l.015.015Z"
    />
    <path
      fill="#733127"
      d="M340.806 66.034c-6.553-1.356-66.206-10.054-72.834-10.516-6.628-.462-66.087.908-66.087.908l5.868 41.765s56.912-17.338 61.827-17.501c4.439-.15 43.85.03 59.013.074 14.477.045 16.443-13.852 12.228-14.73h-.015Z"
    />
    <path
      fill="#733127"
      d="M197.207 52.405c-16.845 1.534-30.25 18.737-100.791 30.28l127.095 14.91s44.252 4.022 48.541 5.169c4.945 1.34 45.593 14.998 58.581 21.016 15.535 7.194 24.799-5.511 20.018-8.609-14.299-9.28-68.604-38.994-73.817-40.692-22.789-7.477-66.058-23.295-79.642-22.059l.015-.015Z"
    />
    <path
      fill="#733127"
      d="M317.452 155.877c-.715-1.206-29.64-50.09-40.156-59.131-25.067-21.537-61.722-32.902-67.68-33.677-8.654-1.117-74.786 13.495-113.199 19.617-35.017 5.585-64.374 4.93-64.374 4.93l7.939 78.494s43.313-13.152 58.52-16.682c17.77-4.126 22.149 3.307 44.207 12.333 27.734 11.349 34.049 12.288 65.909 44.058 12.615 12.586 14.016 21.79 16.131 21.79 1.921 0 4.855-1.653 6.449-3.902 1.549-2.175 4.558-10.143 3.887-15.743-1.325-11.112-10.754-26.111-21.686-36.909-14.224-14.061-22.789-27.719-21.18-47.544.953-11.885 12.467-20.852 20.465-21.746 18.097-2.025 35.643 6.986 49.36 18.455 8.922 7.447 30.177 31.234 35.896 37.4 8.311 8.981 20.897.611 19.497-1.743h.015Z"
    />
    <path
      fill="#3C0000"
      d="M63.858 86.469c-18.901 1.43-31.815 1.147-31.815 1.147l3.307 32.678c4.527-14.134 13.017-30.37 28.508-33.84v.015Z"
    />
  </Box>
)
export default MobileCare
